import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { PENDING } from '../../../design-system/constants';
import {
    postMessageTemplateRequest,
    postMessageTemplateStatus,
} from '../../../resources/message-template';
import { useTrackEventAmplitude } from '../../../shared/analytics';
import { useAppDispatch, useAppSelector } from '../../../shared/redux';

import s from '../MessageTemplates.module.css';

import { Form } from './Form';

export const MessageTemplateNew = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { trackEvent } = useTrackEventAmplitude();
    const isLoading = useAppSelector((state) => postMessageTemplateStatus(state) === PENDING);

    const handleMessageTemplateCreation = (messageTemplate: { title: string; content: string }) => {
        dispatch(postMessageTemplateRequest(messageTemplate, () => navigate('/templates/list')));
        trackEvent((ampli, defaultProperties) => {
            ampli.newTemplateSubmitted(defaultProperties);
        });
    };

    return (
        <div className={s.messageTemplateFormContainer} data-spec-id="message-templates-new-page">
            <h1 className={s.title}>
                <FormattedMessage id="templates.bo.new" />
            </h1>
            <Form submit={handleMessageTemplateCreation} isSubmitting={isLoading} />
        </div>
    );
};
